import React, { useEffect, useState } from "react";
import { Col, Row, Card } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import api from "../../utils/api";
import { Routes } from "../../routes";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUserPlus, faFlag, faLayerGroup, faHeart, faCommentDots, faNewspaper, faCreditCard } from '@fortawesome/free-solid-svg-icons';

const DashboardOverview = () => {
  const [counters, setCounters] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setError('');
    api.get('/stats/overview').then(({ data }) => {
      if (mounted && data && !data.error) {
        setCounters(data.data?.counters || {});
      } else if (mounted && data && data.error) {
        setError(data.message || 'Failed to load overview');
      }
    }).catch((err) => {
      console.error('Dashboard overview API error:', err);
      if (mounted) setError(err?.response?.data?.message || err.message || 'Failed to load overview');
    }).finally(() => mounted && setLoading(false));
    return () => { mounted = false };
  }, []);

  const cards = [
    { key: 'usersTotal', title: 'Total Users', route: Routes.NewUsersList.path, icon: faUsers, color: ['#7c3aed', '#06b6d4'] },
    { key: 'newUsers7d', title: 'New Users (7d)', route: Routes.NewUsersList.path, icon: faUserPlus, color: ['#0ea5e9', '#7c3aed'] },
    { key: 'reportedProfiles', title: 'Reported Profiles', route: Routes.UsersReportsList.path, icon: faFlag, color: ['#ef4444', '#f97316'] },
    { key: 'groupsCount', title: 'Groups', route: Routes.GroupsList.path, icon: faLayerGroup, color: ['#10b981', '#06b6d4'] },
    { key: 'matchesTotal', title: 'Total Matches', route: Routes.DashboardOverview.path, icon: faHeart, color: ['#ef4899', '#fb7185'] },
    { key: 'testimonials', title: 'Testimonials', route: Routes.TestimonialsList.path, icon: faCommentDots, color: ['#3b82f6', '#06b6d4'] },
    { key: 'news', title: 'News', route: Routes.NewsList.path, icon: faNewspaper, color: ['#f59e0b', '#f97316'] },
    { key: 'subscriptionsActive', title: 'Active Subscriptions', route: Routes.SubscriptionList.path, icon: faCreditCard, color: ['#14b8a6', '#06b6d4'] },
  ];

  return (
    <>
      <h3 className="mb-4">Overview</h3>
      <Row className="g-4">
        {cards.map(c => (
          <Col xs={12} sm={6} md={4} lg={4} key={c.key}>
            <Card as={Link} to={c.route} className="h-100 shadow-sm card-hover text-decoration-none text-reset">
              <Card.Body className="d-flex flex-column justify-content-between p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 className="text-muted mb-1">{c.title}</h6>
                    <div className="d-flex align-items-baseline gap-3">
                      <h2 className="fw-bold mb-0" style={{ fontSize: '1.8rem', letterSpacing: '-0.5px' }}>{loading ? '—' : (counters[c.key] ?? 0)}</h2>
                      {/* { (counters && (counters[`${c.key}_change`] !== undefined)) ? (
                        <small className={`badge ${counters[`${c.key}_change`] >= 0 ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger'}`} style={{ fontWeight:700, fontSize:'.78rem' }}> 
                          {counters[`${c.key}_change`] >= 0 ? '+' : ''}{counters[`${c.key}_change`]} 
                        </small>
                      ) : null } */}
                    </div>
                    <p className="text-muted small mt-2 mb-0">{c.subtitle || ''}</p>
                  </div>

                  <div className="ms-3 d-flex align-items-center">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width:64, height:64, background: `linear-gradient(135deg, ${c.color[0]} 0%, ${c.color[1]} 100%)` }}>
                      <FontAwesomeIcon icon={c.icon} size="lg" className="text-white" style={{ fontSize: '1.2rem' }} />
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <style>{`
        .card-hover{transition: transform 220ms cubic-bezier(.2,.8,.2,1), box-shadow 220ms cubic-bezier(.2,.8,.2,1);} 
        .card-hover:hover{transform: translateY(-8px); box-shadow: 0 18px 40px rgba(16,24,40,.12);} 
        .card-hover .bg-light{opacity:.95}
        .bg-soft-success{background-color:#ecfdf5 !important; padding:.15rem .45rem; border-radius:.375rem}
        .bg-soft-danger{background-color:#fff1f2 !important; padding:.15rem .45rem; border-radius:.375rem}
      `}</style>
    </>
  );
}

export default DashboardOverview;